import * as React from "react";
import {Box, Skeleton} from "@mui/material";

const SKELETON_ROWS_COUNT = 5;

export default function TopDebtorsRowsSkeleton() {
    return (
        <Box>
            {Array(SKELETON_ROWS_COUNT).fill(null).map((topDebtorsRowPlaceholder, rowIndex) => (
                <Skeleton key={rowIndex} variant="text" height={32}/>
            ))}
        </Box>
    );
}
